import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const get = async (data: { date: any; columnDate: any; startDate: any; endDate: any }) => {
  return httpRequest.get(`/api/collection/dashboard`, data);
};
